const image = {
    pexels: require('~/images/pexels-photo-237272.jpeg'),
    beach: require('~/images/beach-g6dc238df2_1920.jpg'),
    forest: require('~/images/black-forest-gaf3ef4a97_1920.jpg'),
    QRCode: require('~/images/img-zalo-Hi.jpg'),
    instagram: require('~/images/Instagram-Icon.png'),
    zalo: require('~/images/unnamed.webp'),
    logo: require('~/images/logophongnha.png'),
    imgDiscovery: require('~/images/discovery.jpg'),

    phongNhaVietNam: require('./phong_nha_viet_nam.jpeg'),
    osen: require('./Bang_Osen_Quang_Binh.jpeg'),
    banhXeoBaDon: require('./Banh_Xeo_Ba_Don.jpeg'),
    tuLanLodge: require('./Tu_Lan_Lodge.jpeg'),
    conDuongDaLatQB: require('./con_duong_da_lat_quang_binh.jpeg'),
}

const imageFeature = [
    image.pexels,
    image.beach,
    image.forest
];

export { imageFeature, image };